module.exports = __webpack_public_path__ + "img/no-template.52aa19e2.svg";